import type { SuretyAccount } from "@portal/api/account";
import { BondRequest, useCloseBondRequest } from "@portal/api/bond-request/agent";
import { MoreActionsMenu } from "@portal/components/ui/MoreActionsMenu";
import { useState } from "react";
import { HiOutlineMinusCircle } from "react-icons/hi2";
import { ClosedReasonModal } from "../../../../shared/account/ClosedReasonModal";
import { BondRequestLayout } from "../../../../shared/request/BondRequestLayout";

type DeclinedBondRequestViewProps = {
	request: BondRequest;
	account: SuretyAccount;
};

export const DeclinedBondRequestView = ({ request, account }: DeclinedBondRequestViewProps) => {
	const [showClosedReasonModal, setShowClosedReasonModal] = useState(false);
	const { closeBondRequest, closeBondRequestLoading, closeBondRequestError } = useCloseBondRequest(
		request.suretyAccountId,
		request.id,
	);

	return (
		<BondRequestLayout
			request={request}
			account={account}
			actionButtons={
				<MoreActionsMenu
					items={[
						{
							label: "Close Bond Request",
							icon: <HiOutlineMinusCircle size={16} />,
							onClick: () => setShowClosedReasonModal(true),
							trackingId: "bond-request-agent-close",
						},
					]}
					panelClassName="mt-[10px]"
				/>
			}
			termsAndConditionsOpen
		>
			{showClosedReasonModal && (
				<ClosedReasonModal
					closeFunction={closeBondRequest}
					closeFunctionError={closeBondRequestError}
					isClosing={closeBondRequestLoading}
					onDismiss={() => setShowClosedReasonModal(false)}
					closingAction="close"
				/>
			)}
		</BondRequestLayout>
	);
};
